export default "__VITE_ASSET__Bwla5E$J__"